import type { Address } from 'viem';

import { Web3Predictions__factory } from '@shared/config/contracts/abi-typed';

const WEB3_PREDICTIONS_CONTRACT_ADDRESS_BSC: Address =
  (process.env.NEXT_PUBLIC_PREDICTIONS_CONTRACT_ADDRESS_BSC as Address) ?? '0x0';

export const PREDICTIONS_CONTRACT = {
  abi: Web3Predictions__factory.abi,
  address: WEB3_PREDICTIONS_CONTRACT_ADDRESS_BSC,
};
